import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Swords } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { runAiJob } from '../../lib/aiJob';
import { fmtDate } from '../../lib/dates';

const FORCE = { alta: 'bg-red-500/20 text-red-300', media: 'bg-amber-500/20 text-amber-200', baja: 'bg-slate-700 text-slate-300' };
export const Chip = ({ v }) => <span className={`rounded-full px-2 py-0.5 text-[10px] ${FORCE[v] || FORCE.baja}`}>{v}</span>;

export const OpponentPanel = ({ matter, initial }) => {
  const { api } = useAuth();
  const [data, setData] = useState(initial);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (initial) setData(initial); }, [initial]);
  const run = async () => {
    setBusy(true);
    try { setData(await runAiJob(api, `/cerebro/matters/${matter.id}/opponent`, {}, { timeout: 240000 })); toast.success('Ataques de la contraparte anticipados'); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4 pt-3" data-testid="opponent-panel">
      <button data-testid="opponent-run-btn" onClick={run} disabled={busy} className="w-full rounded-lg bg-fuchsia-500 py-2 text-sm font-semibold text-white hover:bg-fuchsia-400 disabled:opacity-60 flex items-center justify-center gap-2">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Swords className="h-4 w-4" />}{busy ? 'Pensando como la contraparte (≈1 min)...' : data ? 'Volver a simular a la contraparte' : 'Simular al abogado contrario'}
      </button>
      {data && (
        <>
          <div className="rounded-xl border border-fuchsia-500/30 bg-fuchsia-500/5 p-3"><p className="text-xs text-fuchsia-200 font-semibold">Teoría del caso contraria</p><p className="text-sm text-slate-200 mt-1">{data.teoria_contraria}</p></div>
          {data.argumentos?.map((a, i) => (
            <div key={i} data-testid={`opponent-arg-${i}`} className="rounded-xl border border-slate-800 bg-slate-900/70 p-3 space-y-1">
              <p className="text-sm font-semibold text-white flex items-center gap-2">{a.argumento} <Chip v={a.fuerza} /></p>
              <p className="text-xs text-slate-400">Fundamento: {a.fundamento}</p>
              <p className="text-xs text-emerald-300">Réplica: {a.replica}</p>
              {a.prueba_necesaria && <p className="text-xs text-sky-300">Prueba: {a.prueba_necesaria}</p>}
            </div>
          ))}
          {data.excepciones_procesales?.length > 0 && <div className="rounded-xl border border-slate-800 p-3"><p className="text-xs font-semibold text-amber-300 mb-1">Excepciones procesales posibles</p>
            {data.excepciones_procesales.map((x, i) => <p key={i} className="text-xs text-slate-300">• {x.excepcion} <Chip v={x.riesgo} /> — {x.prevencion}</p>)}</div>}
          {data.puntos_debiles_nuestros?.length > 0 && <div className="rounded-xl border border-red-500/30 p-3"><p className="text-xs font-semibold text-red-300 mb-1">Nuestros puntos débiles</p>{data.puntos_debiles_nuestros.map((x, i) => <p key={i} className="text-xs text-slate-300">• {x}</p>)}</div>}
          {data.jugada_sorpresa && <p className="text-xs text-slate-300"><span className="text-fuchsia-300 font-semibold">Jugada sorpresa:</span> {data.jugada_sorpresa}</p>}
          <p className="text-[10px] text-slate-500">{data.disclaimer} · {fmtDate(data.generated_at, true)}</p>
        </>
      )}
    </div>
  );
};
